<template>
  <div class="unread-container">
    <div class="is-read" :class="{ unread: isRead }" />
  </div>
</template>

<script>
  export default {
    name: 'IsReadStatus',
    props: {
      isRead: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .is-read {
    width: 12px;
    height: 12px;
    background: $info500;
    border-radius: 50%;
    &.unread {
      background: white;
      border: 1px solid #dadde2;
    }
  }

  .unread-container {
    width: 20px;
    display: flex;
    justify-content: center;
  }
</style>
